import { gql } from '@apollo/client'

const UPDATE_INGREDIENT_NOTES_MUTATION = gql`
  mutation updateIngredientNotes($id: ID!, $data: IngredientNotesInput!) {
    updateIngredientNotes(id: $id, data: $data) {
      id
      updatedAt
      updatedBy {
        id
        name
      }
      notes
    }
  }
`

export default UPDATE_INGREDIENT_NOTES_MUTATION
